    function fncallingPh(AdId) {
        $.ajax({
            url: pzAdDetailMore.v0,
            type: "get",
            contentType: "application/json",
            processData: false,
        })
        .done(function (data) {
            console.log("Call saved");
        })
        .fail(function (data) {

        });
    }

    function RenewalDisableMsg() {
        $('#editAdErrorMsg').show();
        setTimeout(function () { $('#editAdErrorMsg').hide(); }, 10000);
    }

    $(".saveAd").click(function (e) {
        var userIsAuth = pzAdDetailMore.v1;
        if (!userIsAuth) {
            var signInUrl = pzAdDetailMore.v2;
            window.location = signInUrl
                + (signInUrl.indexOf('?') === -1 ? '?' : '&')
                + 'returnUrl=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        else {
            $.ajax({
                url: pzAdDetailMore.v3,
                data: JSON.stringify(pzAdDetailMore.v4),
                type: "get",
                contentType: "application/json",
                processData: false,
            })
            .done(function (data) {
                $('.saveAd').addClass("active");
            })
            .fail(function (data) { });
        }
    });
;
    function EnableSimilarAdsShimmer(flag) {

        if (flag) {
            for (var i = 0; i < 4; i++) {
                $('.similarAdsRow').append('<div class="bootstrap4 col-6 col-sm-6 col-md-4 col-lg-3 goods-card shimmerCard"><a><div class="ad-image-container"><div class="responsive-shimmer-block details-similar-ad-image"><div class="content"><span></span></div><div class="shimmer"></div></div></div><div class="ad-info"><div class="responsive-shimmer-block details-similar-ad-title"><div class="content"><span></span></div><div class="shimmer"></div></div><div class="responsive-shimmer-block details-similar-ad-date"><div class="content"><span></span></div><div class="shimmer"></div></div><div class="responsive-shimmer-block details-similar-ad-price"><div class="content"><span></span></div><div class="shimmer"></div></div></div></a></div>');
            }
            $('.shimmerSimilarAdMoreButton').removeClass('hidden');
            $('.btnSimilarAdsMore').addClass('hidden');
        }
        else {
            $('.shimmerCard').remove();
            $('.shimmerSimilarAdMoreButton').addClass('hidden');
            $('.btnSimilarAdsMore').removeClass('hidden');
        }
    }
    $(document).ready(function (e) {
        EnableSimilarAdsShimmer(true);
        $.ajax({
            url: pzAdDetailMore.v5,
            type: "get",
            contentType: "text/html",
            processData: false,
        })
        .done(function (data) {
            $('#recently-reviewed-ads-place').append(data)
        }).fail(function (data) { });

        $.ajax({
            url: pzAdDetailMore.v6,
            type: "get",
            //contentType: "text/html",
            processData: false,
        })
            .done(function (data) {
                EnableSimilarAdsShimmer(false);
                $('#similar-ads-place').append(data.html);
                moneyFormat();
        })
        .fail(function (data) { });


        $('.remove-recently-reviewed-ad').click(function (e) {
            e.preventDefault();
            var id = $(this).data('item-id');

            $.ajax({
                url: (pzAdDetailMore.v7 + "&AdId=") + id,
                type: "post",
                contentType: "application/json",
                processData: false,
            }).done(function (data) {
                $('#recently-reviewed-ad-' + id).remove();
            }).fail(function (data) { });
        });

        $('.custom-photo').each(function (element) {
            $('.custom-photo-link').data("width", ($(this).width()));
            $('.custom-photo-link').data("height", ($(this).height()));
        })

        $('.full-screen-button').click(function (element) {
            $('.carousel-item.active .custom-photo').click();
        })
    });
;
    var mapInited = false;
    $(document).ready(function () {
        $('.modal-close').click(function () {
            $('.modal-custom').removeClass('active');
            $('body').removeClass('modal-custom-show');
        });

        $('*[data-show]').click(function () {
            if ($(this).attr('data-show') == "custom-modal") {
                var displayId = "#" + $(this).attr('data-target');
                $('body').addClass('modal-custom-show');
                $(displayId).addClass('active');
                var IsMap = pzAdDetailMore.v8 + "";
                var IsStore = pzAdDetailMore.v9 + "";
                if (!mapInited) {
                    if (IsStore != "" && IsStore.toLowerCase() == "true") {
                        mapInited = true;
                        mapInitStore();
                    }
                    else if (IsMap != "" && IsMap.toLowerCase() == "true") {
                        mapInited = true;
                        mapInit();
                    }
                }
            };
        });
    });

    $(document).mouseup(function (a) {
        var div = $(".modal-custom .modal-window");
        if (!div.is(a.target)
            && div.has(a.target).length === 0) {
            $('.modal-custom').removeClass('active');
            $('body').removeClass('modal-custom-show');
        };
    });
